import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO = 'https://customer-assets.emergentagent.com/job_buraq-transport/artifacts/0a9wh5vw_0E081036-6309-4011-9127-0A9FE497D0F8.png';
const TABS = [['book', 'Book a ride', '/business/book'], ['rides', 'Rides', '/business/rides'], ['travelers', 'Travelers', '/business/travelers'], ['settings', 'Settings', '/business/settings']];

// The business portal frame: the same dark RideBuraq look as the booking page, a quiet header and four tabs. A booker has no Settings tab.
export default function BusinessLayout({ active, company, role, title, subtitle, children, wide = false }) {
  const navigate = useNavigate();
  const tabs = TABS.filter(([key]) => key !== 'settings' || role === 'admin');
  return (
    <div className="min-h-screen bg-[#0d0e11] text-gray-50 relative" style={{ overflowX: 'clip' }} data-testid="business-portal">
      <div className="rb-ambient" aria-hidden="true">{['a', 'b', 'e'].map((k) => <div key={k} className={`rb-glow rb-glow-${k}`} />)}</div>
      <div className={`relative w-full mx-auto px-6 sm:px-10 ${wide ? 'max-w-[1400px]' : 'max-w-5xl'} pb-16`}>
        <header className="flex items-center justify-between py-5">
          <button type="button" onClick={() => navigate('/dashboard')} aria-label="Back to your account" className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-gray-300 hover:text-white hover:border-white/60 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white/70">
            <ArrowLeft className="h-4 w-4" />
          </button>
          <button type="button" onClick={() => navigate('/business')} aria-label="Business home" className="flex items-center gap-2.5">
            <img src={LOGO} alt="" className="w-9 h-9 object-contain" />
            <span className="text-xl font-bold tracking-wide">Ride<span className="text-white">Buraq</span> <span className="text-sm font-normal tracking-[0.2em] uppercase text-gray-300 ml-1">Business</span></span>
          </button>
        </header>
        {company && (
          <nav aria-label="Business" className="flex flex-wrap items-center gap-x-1 gap-y-1 border-b border-white/10 mb-8" data-testid="business-tabs">
            {tabs.map(([key, label, path]) => (
              <button key={key} type="button" onClick={() => navigate(path)} data-testid={`tab-${key}`} aria-current={active === key ? 'page' : undefined}
                className={`min-h-[44px] px-4 text-base border-b-2 -mb-px transition-colors focus-visible:outline-none focus-visible:text-white ${active === key ? 'border-orange-500 text-white font-medium' : 'border-transparent text-gray-300 hover:text-white'}`}>{label}</button>
            ))}
            <span className="ml-auto text-sm text-gray-300 py-2" data-testid="company-name">{company.name}</span>
          </nav>
        )}
        {(title || subtitle) && (
          <div className="mb-8">
            {title && <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h1>}
            {subtitle && <p className="text-base text-gray-300 mt-2 max-w-2xl leading-relaxed">{subtitle}</p>}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
